import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const StyleArticle = lazy(() => import('pages/style-article'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_empty/style-article')({
  component: StyleArticleWrapper,
});

function StyleArticleWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <StyleArticle />
    </Suspense>
  );
}
